namespace Gamification.Gamification {
    export interface UtentiProdottiEsperienzeTaskRow {
        UserId?: number;
        TenantId?: number;
        IdUtenteProdottoEsperienzeTask?: number;
        IdUtenteProdottoEsperienza?: number;
        IdProdottoEsperienzaTask?: number;
        DataOraInizio?: string;
        DataOraFine?: string;
        Stato?: number;
        IdUtenteProdottoEsperienzaIdUtenteProdotto?: number;
        IdUtenteProdottoEsperienzaIdProdottoEsperienza?: number;
        IdUtenteProdottoEsperienzaValore?: number;
        IdUtenteProdottoEsperienzaDataOraInizio?: string;
        IdUtenteProdottoEsperienzaDataOraFine?: string;
        IdUtenteProdottoEsperienzaStato?: number;
        IdProdottoEsperienzaTaskNome?: string;
    }

    export namespace UtentiProdottiEsperienzeTaskRow {
        export const idProperty = 'IdUtenteProdottoEsperienzeTask';
        export const localTextPrefix = 'Gamification.UtentiProdottiEsperienzeTask';
        export const lookupKey = 'Gamification.UtentiProdottiEsperienzeTask';

        export function getLookup(): Q.Lookup<UtentiProdottiEsperienzeTaskRow> {
            return Q.getLookup<UtentiProdottiEsperienzeTaskRow>('Gamification.UtentiProdottiEsperienzeTask');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtenteProdottoEsperienzeTask = "IdUtenteProdottoEsperienzeTask",
            IdUtenteProdottoEsperienza = "IdUtenteProdottoEsperienza",
            IdProdottoEsperienzaTask = "IdProdottoEsperienzaTask",
            DataOraInizio = "DataOraInizio",
            DataOraFine = "DataOraFine",
            Stato = "Stato",
            IdUtenteProdottoEsperienzaIdUtenteProdotto = "IdUtenteProdottoEsperienzaIdUtenteProdotto",
            IdUtenteProdottoEsperienzaIdProdottoEsperienza = "IdUtenteProdottoEsperienzaIdProdottoEsperienza",
            IdUtenteProdottoEsperienzaValore = "IdUtenteProdottoEsperienzaValore",
            IdUtenteProdottoEsperienzaDataOraInizio = "IdUtenteProdottoEsperienzaDataOraInizio",
            IdUtenteProdottoEsperienzaDataOraFine = "IdUtenteProdottoEsperienzaDataOraFine",
            IdUtenteProdottoEsperienzaStato = "IdUtenteProdottoEsperienzaStato",
            IdProdottoEsperienzaTaskNome = "IdProdottoEsperienzaTaskNome"
        }
    }
}
